import collecting from "./collecting";
import layout from "./layout";
import page from "./page";
import project from "./project";
import resource from "./resource";
import text from "./text";

export default `
  ${collecting}
  ${layout}
  ${page}
  ${project}
  ${text}
  ${resource}
`;
